import { Box, Container } from '@mui/material';

// Components
import SiteBranding from '../../base/branding/sitebranding';
import Footer from '../../base/layout/Footer';

export default function AppUserPasswordResetOk() {
  return (
    <>
      <div className='app'>
        <main className='content'>
          <div className='content_body'>
            <Container maxWidth={'md'}>
              <Box display='flex' justifyContent='center' className='logoBox'>
                <Box display='flex'>
                  <SiteBranding className='logo' />
                </Box>
              </Box>
              <Box display='flex' justifyContent='center' className='logoBox'>
                <Box display='flex'>
                  <h1>Password updated!</h1>
                </Box>
              </Box>
              <Box display='flex' justifyContent='center' className='logoBox'>
                <Box display='flex'>
                  <p>
                    You may now <a href='/dashboard'>login</a> with your new password
                  </p>
                </Box>
              </Box>
              <Footer />
            </Container>
          </div>
        </main>
      </div>
    </>
  );
}
